import { Theme } from "@mui/material";
import { colors, hoverColors } from "../../constants/colors";

const styles = {
  backgroundColor: colors.white,
  color: colors.black,
};

const optionsTabsStyles: any = (theme?: Theme) => styles;

export default optionsTabsStyles;